import { getFragmentMediaProgressPercent } from '@app/modules/fragments/utils/get-fragment-media-progress-percent';
import { useFragment } from '../../hooks/useFragment';
import { FragmentMediaPlayerSkeleton } from './FragmentMediaPlayerSkeleton';
import { FragmentMediaStalledLoader } from './FragmentMediaStalledLoader';

/**
 * Shows the audio or video skeleton with media generation progress while the fragment is processing.
 * When generation is stalled, keeps the normal progress and adds a regenerate chip.
 */
export function FragmentMediaLoading() {
  const { fragment } = useFragment();
  const isVideo = fragment.mediaType === 'VIDEO';
  const mediaProgressPercent = getFragmentMediaProgressPercent(fragment);

  return (
    <FragmentMediaPlayerSkeleton
      aspectRatio={isVideo ? '16 / 9' : '16 / 3'}
      progressPercent={mediaProgressPercent}
      loader={
        fragment.isMediaGenerationStalled ? (
          <FragmentMediaStalledLoader progressPercent={mediaProgressPercent} />
        ) : undefined
      }
    />
  );
}
